import {
  ArrowRight,
  BookOpenCheck,
  Languages,
  MessageCircleMore,
  Sparkles,
  Volume2,
} from "lucide-react";
import { Link } from "react-router-dom";
import { Card } from "../components/ui";

export function LearningPage() {
  return (
    <div className="learning-hub">
      <Card className="learning-hub-intro">
        <span className="learning-hub-mark">
          <Sparkles />
        </span>
        <div>
          <span>MY LANGUAGE JOURNEY</span>
          <h2>今天想学习哪一种语言？</h2>
          <p>英语与法语拥有各自独立的课程、词库和学习进度。</p>
        </div>
      </Card>

      <section className="learning-language-grid" aria-label="选择学习语言">
        <Link className="learning-language-card english" to="/words">
          <span className="learning-language-icon">
            <BookOpenCheck />
          </span>
          <div>
            <small>ENGLISH</small>
            <h2>英语学习</h2>
            <p>日常英语 · 真人精听 · IELTS</p>
          </div>
          <span className="learning-language-skills" aria-hidden="true">
            <Volume2 />
            <MessageCircleMore />
          </span>
          <strong>
            进入英语 <ArrowRight />
          </strong>
        </Link>

        <Link className="learning-language-card french" to="/french">
          <span className="learning-language-icon">
            <Languages />
          </span>
          <div>
            <small>FRANÇAIS</small>
            <h2>法语学习</h2>
            <p>日常法语 · 发音听力 · DELF</p>
          </div>
          <span className="learning-language-skills" aria-hidden="true">
            <Volume2 />
            <MessageCircleMore />
          </span>
          <strong>
            进入法语 <ArrowRight />
          </strong>
        </Link>
      </section>
    </div>
  );
}
